import React from 'react';
import './Appys.scss';
import IPADescription from './IPADescription/IPADescription';
import IPAOrthography from './IPAOrthography/IPAOrthography';
import IPAFeatures from './IPAFeatures/IPAFeatures';

class Appys extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div>
                <IPAFeatures />
                <IPAOrthography />
                <IPADescription />
            </div>
        )
    }
}

export default Appys;